import {
  Alert,
  AlertDescription,
  AlertIcon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import { Fragment, FunctionComponent, useState } from 'react'
import { Patient } from '../../types'
import { LimitedPrescriberProfile } from '../../features/users/UsersSlice'
import PatientRegistration from '../../features/patient-registration/PatientRegistration'

interface NewPatientModalProps {
  onAdd?: (patient: Patient) => void
  children: FunctionComponent<{
    openModal: () => void
  }>
  hidePrescriberSelection?: boolean
  selectedPrescriber: LimitedPrescriberProfile | null
  onPrescriberChange?: (id: string) => void
}

const NewPatientModal: FunctionComponent<NewPatientModalProps> = ({
  onAdd,
  children: ChildrenComponent,
  hidePrescriberSelection = false,
  selectedPrescriber,
  onPrescriberChange,
}) => {
  const [modalIsOpen, setModelIsOpen] = useState<boolean>(false)
  const handleCloseCreation = () => {
    setModelIsOpen(false)
  }

  return (
    <Fragment>
      <ChildrenComponent openModal={() => setModelIsOpen(true)} />
      <Modal isOpen={modalIsOpen} onClose={handleCloseCreation} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent width="100%" maxWidth="1000px">
          <ModalHeader>New Patient</ModalHeader>
          <ModalCloseButton />
          {modalIsOpen && (
            <PatientRegistration
              selectedPrescriber={selectedPrescriber}
              onPrescriberChange={onPrescriberChange}
              hidePrescriberSelection={hidePrescriberSelection}
              onCancel={handleCloseCreation}
              onCreated={(patient) => {
                onAdd?.(patient)
                handleCloseCreation()
              }}
            >
              {({ form, error, submitButton }) => (
                <>
                  <ModalBody>{form}</ModalBody>
                  <ModalFooter>
                    {error && (
                      <Alert status="error" mr={3}>
                        <AlertIcon />
                        <AlertDescription>{error.message}</AlertDescription>
                      </Alert>
                    )}
                    {submitButton}
                  </ModalFooter>
                </>
              )}
            </PatientRegistration>
          )}
        </ModalContent>
      </Modal>
    </Fragment>
  )
}

export default NewPatientModal
